<div fxLayout="row" fxLayoutAlign="center center">
  <img src="/assets/img/logo.png" />
  <span class="mat-display-1 push-none pad-sm-left">Placement</span>
</div>
<mat-divider class="push"></mat-divider>
<div fxLayout="column">
  <p id="version" class="mat-subheading-1">
    <span i18n>Version</span>: {{ version }}
  </p>
  <p id="commit" class="mat-subheading-1">
    <span i18n>Build</span>: {{ commit }}
  </p>
  <p id="date" class="mat-subheading-1"><span i18n>Date</span>: {{ date }}</p>
</div>
